import { render, staticRenderFns } from "./ProductCertificationsTab.vue?vue&type=template&id=42b86484&scoped=true&"
import script from "./ProductCertificationsTab.vue?vue&type=script&lang=js&"
export * from "./ProductCertificationsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b86484",
  null
  
)

export default component.exports